import React from "react";
import { Modal } from "semantic-ui-react";
import { Dropdown } from "semantic-ui-react";

import { getText } from "../../helpers";
import { CHANGE_LOG_FILTERS } from "../../constants";
import UnwantedEventLogsTable from "./unwanted_event_logs_modal_table";
import "./unwanted_event_logs_modal.css";

const UnwantedEventLogsModal = (props) => {
  const [filters, setFilters] = React.useState([
    "tagged_as_pue_log",
    "new_unwanted_event_log",
  ]);
  const filterOptions = CHANGE_LOG_FILTERS.map((filter) => ({
    ...filter,
    text: getText(filter.text),
  }));

  const handleDropdownChange = (e, { value }) => {
    setFilters(value);
  };

  return (
    <Modal open size="large">
      <Modal.Content>
        <div className="unwanted-event-logs-modal-header">
          <i className="delete icon" onClick={props.onClose}></i>
          <div id="unwanted-event-logs-instructions">
            {getText("Plan Change Logs")}
            <Dropdown
              className="log-filters-dropdown"
              placeholder={getText("Filter Change Logs")}
              value={filters}
              options={filterOptions}
              onChange={handleDropdownChange}
              fluid
              multiple
              selection
              closeOnBlur
              closeOnChange
            />
          </div>
          <div className="delete-icon-position"></div>
        </div>
        <UnwantedEventLogsTable planId={props.planId} filters={filters} />
      </Modal.Content>
    </Modal>
  );
};

export default UnwantedEventLogsModal;



// WEBPACK FOOTER //
// ./src/views/unwanted_event_logs_modal/unwanted_event_logs_modal.js